var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "lp1" } }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row p-0 m-0", staticStyle: { "min-height": "450px" } },
        [
          !_vm.notExists
            ? _c(
                "div",
                {
                  staticClass:
                    "mx-auto bg-white shadow rounded col-md-12 col-10 p-0 m-0",
                },
                [
                  _vm.iframeUrl != null
                    ? _c("iframe", {
                        staticStyle: {
                          width: "100%",
                          height: "100%",
                          overflow: "hidden !important",
                          border: "none",
                          "border-radius": "8px",
                        },
                        attrs: {
                          allowtransparency: "true",
                          src: _vm.iframeUrl,
                        },
                      })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }